import { AxiosResponse } from 'axios';

import { IGuarantorDocument } from '../../shared/ts/document';
import { IGuarantor } from '../../shared/ts/guarantor';
import httpRequest from '../httpRequest';
const baseURL = process.env.REACT_APP_GW_API_URL;

const guarantorsAPI = {
  getBookingGuarantors: async (bookingId: string): Promise<IGuarantor[]> => {
    const { data } = (await httpRequest({
      url: `/guarantor?booking_id=${bookingId}`,
      method: 'GET',
    })) as AxiosResponse;

    return data ? data : [];
  },
  getGuarantor: async (id: number): Promise<IGuarantor> => {
    const { data } = (await httpRequest({
      url: `/guarantor/${id}`,
      method: 'GET',
    })) as AxiosResponse;

    return data;
  },
  postGuarantor: async (
    payload: {
      booking_id: string;
      first_name: string;
      last_name: string;
      occupation: string;
      tax_code?: string;
      email?: string;
      income?: number;
      place_of_birth?: string;
      date_of_birth?: string;
      user_id?: number;
      no_tax_code_declaration?: boolean;
    },
    isMyself = false,
  ): Promise<IGuarantor> => {
    const { data } = (await httpRequest({
      url: `/guarantor${isMyself ? '/me' : ''}`,
      method: 'POST',
      data: payload,
    })) as AxiosResponse;

    return data;
  },
  updateGuarantor: async (
    payload: {
      booking_id: string;
      first_name: string;
      last_name: string;
      occupation: string;
      isGuarantorGuest?: boolean | null;
      tax_code?: string;
      email?: string;
      income?: number;
      place_of_birth?: string;
      date_of_birth?: string;
      user_id?: number | null;
      no_tax_code_declaration?: boolean;
    },
    id: number,
  ): Promise<IGuarantor> => {
    const { data } = (await httpRequest({
      baseURL: baseURL,
      url: `/dalgona/guarantors/${id}`,
      method: 'PUT',
      data: payload,
    })) as AxiosResponse;

    return data;
  },
  deleteGuarantor: async (id: number): Promise<IGuarantor> => {
    const { data } = (await httpRequest({
      url: `/guarantor/${id}`,
      method: 'DELETE',
    })) as AxiosResponse;

    return data;
  },
  getGuarantorDocuments: async (id: number): Promise<IGuarantorDocument[]> => {
    const { data } = (await httpRequest({
      url: `guarantor/document?guarantor_id=${id}`,
      method: 'GET',
    })) as AxiosResponse;

    return data;
  },
  postGuarantorDocument: async (
    payload: IGuarantorDocument,
    onProgress: (progressEvent: ProgressEvent) => void,
  ): Promise<IGuarantorDocument> => {
    const { data } = (await httpRequest({
      url: `guarantor/document`,
      method: 'POST',
      data: payload,
      onUploadProgress(progressEvent) {
        onProgress(progressEvent);
      },
    })) as AxiosResponse;

    return data;
  },
  deleteGuarantorDocument: async (
    id: number,
    documentSide?: string,
  ): Promise<IGuarantorDocument> => {
    const { data } = (await httpRequest({
      url: `guarantor/document/${id}${
        documentSide ? `?side=${documentSide}` : ''
      }`,
      method: 'DELETE',
    })) as AxiosResponse;

    return data;
  },
};

export default guarantorsAPI;
